const API_PARAMETERS_TYPES = {
  TEXT: 'Text',
  NUMBER: 'Number',
  DATE: 'Date',
  DATETIME: 'DateTime',
  DATETIMEZONE: 'DateTimeZone',
  DURATION: 'Duration',
  LOGICAL: 'Logical',
  BINARY: 'Binary',
  ANY: 'Any'
};

const buildDefaultValue = param => {
  switch (param.type) {
    case 'Duration': {
      const [days, time] = param.currentValue.split('.');
      const [hours, minutes] = time.split(':');
      return {days: Number(days), hours: Number(hours), minutes: Number(minutes)};
    }

    case 'DateTimeZone': {
      // Handles both "2026-02-01T08:30:00Z" and "2026-02-01T10:30:00+01:00"
      const value = param.currentValue;

      if (!value) return {datetime: '', timezone: '+00:00'};

      if (value.endsWith('Z')) {
        return {datetime: value.slice(0, -1), timezone: '+00:00'};
      }

      // Split at the last '+' or '-' for offsets
      const match = value.match(/(.+)([+-]\d{2}:\d{2})$/);
      if (!match) return {datetime: value, timezone: '+00:00'}; // fallback

      const [, datetime, timezone] = match;
      return {datetime, timezone};
    }

    default:
      return param.currentValue ?? '';
  }
};

const serializeValue = (param, value) => {
  switch (param.type) {
    case 'Duration': {
      const {days = 0, hours = 0, minutes = 0} = value ?? {};
      const pad = n => String(n).padStart(2, '0');
      return `${days}.${pad(hours)}:${pad(minutes)}:00`;
    }

    case 'DateTimeZone': {
      if (!value) return '';
      const {datetime, timezone} = value;

      if (timezone === '+00:00') {
        return `${datetime}Z`; // use 'Z' for UTC
      }

      return `${datetime}${timezone}`;
    }

    default:
      return value ?? '';
  }
};

const serializeParameters = (formParameters, parametersDef) => {
  const paramByName = Object.fromEntries(parametersDef.map(p => [p.name, p]));

  return Object.entries(formParameters).map(([key, value]) => {
    const param = paramByName[key];
    return {
      name: key,
      newValue: param ? serializeValue(param, value) : value
    };
  });
};

const TIMEZONES = [
  {label: 'UTC −12:00', value: '-12:00'},

  {label: 'Anchorage / Alaska (UTC−09:00)', value: '-09:00'},
  {label: 'Los Angeles / USA (UTC−08:00)', value: '-08:00'},
  {label: 'Denver / USA (UTC−07:00)', value: '-07:00'},
  {label: 'Chicago / USA (UTC−06:00)', value: '-06:00'},
  {label: 'New York / USA (UTC−05:00)', value: '-05:00'},

  {label: 'Buenos Aires / South America (UTC−03:00)', value: '-03:00'},

  {label: 'UTC (UTC±00:00)', value: '+00:00'},

  {label: 'Paris / Europe (UTC+01:00)', value: '+01:00'},
  {label: 'Athens / Europe (UTC+02:00)', value: '+02:00'},
  {label: 'Moscow / Europe (UTC+03:00)', value: '+03:00'},

  {label: 'Dubai / Middle East (UTC+04:00)', value: '+04:00'},
  {label: 'Tehran / Middle East (UTC+03:30)', value: '+03:30'},

  {label: 'Karachi / Asia (UTC+05:00)', value: '+05:00'},
  {label: 'Mumbai / India (UTC+05:30)', value: '+05:30'},
  {label: 'Kathmandu / Nepal (UTC+05:45)', value: '+05:45'},

  {label: 'Bangkok / Asia (UTC+07:00)', value: '+07:00'},
  {label: 'Singapore / Asia (UTC+08:00)', value: '+08:00'},
  {label: 'Perth / Australia (UTC+08:00)', value: '+08:00'},

  {label: 'Tokyo / Asia (UTC+09:00)', value: '+09:00'},
  {label: 'Adelaide / Australia (UTC+09:30)', value: '+09:30'},

  {label: 'Sydney / Australia (UTC+10:00)', value: '+10:00'},
  {label: 'Auckland / New Zealand (UTC+12:00)', value: '+12:00'},

  {label: 'Kiritimati / Pacific (UTC+14:00)', value: '+14:00'}
];

export {serializeParameters, buildDefaultValue, API_PARAMETERS_TYPES, TIMEZONES};
